import { generateTypes } from '../../utils/HttpReducerHelper';

const conversationsData = generateTypes('MONITOR_CLIENT', 'CONVERSATIONS');

const OPEN_CONVERSATIONS_PANEL = 'platfi-ui-app/MONITOR/OPEN_CONVERSATIONS_PANEL';
const CLOSE_CONVERSATIONS_PANEL = 'platfi-ui-app/MONITOR/CLOSE_CONVERSATIONS_PANEL';
const SET_CONVERSATION_FILTERS = 'platfi-ui-app/MONITOR/SET_CONVERSATION_FILTERS';

export {
  conversationsData,
  CLOSE_CONVERSATIONS_PANEL,
  OPEN_CONVERSATIONS_PANEL,
  SET_CONVERSATION_FILTERS,
};
